package org.ksdfv.thelema.utils

/** @author zeganstyl */
interface ILog {
    var infoEnabled: Boolean
    var debugEnabled: Boolean
    var errorEnabled: Boolean

    fun info(message: String, exception: Throwable?, tag: String = "")
    fun debug(message: String, exception: Throwable?, tag: String = "") {
        if (debugEnabled) info(message, exception, tag)
    }
    fun error(message: String, exception: Throwable?, tag: String = "")

    fun info(message: String, tag: String = "") = info(message, null, tag)
    fun debug(message: String, tag: String = "") = debug(message, null, tag)
    fun error(message: String, tag: String = "") = error(message, null, tag)
}